module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Battles-BC.3fd515f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Battles-BC.jpg
// module id = iXRj
// module chunks = 0